import throttle from 'lodash/throttle';

const blocks = document.querySelectorAll('.block-content-background-image');

const setBlockProperties = () => {
	blocks.forEach((block) => {
		const contentBlock = block.querySelector(
			'.block-content-background-image-content-box'
		);

		if (contentBlock) {
			block.style.setProperty(
				'--contentTop',
				`${(contentBlock.getBoundingClientRect().top - block.getBoundingClientRect().top) / 16}rem`
			);
		}
	});
};

if (blocks.length > 0) {
	setBlockProperties();
	window.addEventListener('resize', throttle(setBlockProperties, 100));
}
